import { PATIENT_STATUSES } from 'features/Home/constants/infoConstants'
import { type IPatientSchedule } from 'features/Home/interfaces/IInfoSchedule'

export const CANCELED_STATUS_CODES = [
  PATIENT_STATUSES.CANCELED,
  PATIENT_STATUSES.CANCEL_PATIENT,
  PATIENT_STATUSES.CANCELED_24H,
]

/** Canceled statuses + Reschedule (Canceled) — hidden when "Show canceled" is unchecked. */
export const HIDDEN_WHEN_SHOW_CANCELED_OFF = [
  ...CANCELED_STATUS_CODES,
  PATIENT_STATUSES.RESCHEDULE,
]

export const sortCanceledSchedules = (schedules: IPatientSchedule[]): IPatientSchedule[] => {
  return [...schedules].sort((a, b) => {
    const aCanceled = CANCELED_STATUS_CODES.includes(a.status.code)
    const bCanceled = CANCELED_STATUS_CODES.includes(b.status.code)

    if (aCanceled && !bCanceled) return 1
    if (!aCanceled && bCanceled) return -1
    return 0
  })
}

export const filterCanceledSchedules = (
  schedules: IPatientSchedule[],
  showCanceled: boolean,
): IPatientSchedule[] => {
  if (showCanceled) return schedules

  return schedules.filter(
    (schedule) => !HIDDEN_WHEN_SHOW_CANCELED_OFF.includes(schedule.status.code),
  )
}

export const isScheduleDaySyncedToDate = (
  date: string | null | undefined,
  scheduleDay: { items: Array<{ date?: string }> } | null | undefined,
): boolean => {
  if (!date || !scheduleDay) return false
  if (!scheduleDay.items.length) return true
  return scheduleDay.items.some((item) => item.date === date)
}
